import { z } from "zod";

export const ProfileSchema = z.object({
  loginId: z.string(),

  agentName: z
    .string()
    .trim()
    .min(1, "Agent name is required")
    .max(50, "Agent name must not exceed 50 characters")
    .regex(
      /^[A-Za-z\s]+$/,
      "Agent name can only contain letters and spaces",
    ),

  email: z.string(),

 contactNoCountryCode: z.string().min(1, "Please select a country code."),

  contactNo: z
  .string()
  .trim()
  .min(1, "Contact no is required")
  .max(15, "Contact no must not exceed 15 digits")
  .regex(
    /^\d+$/,
    "Contact no can only contain numbers",
  ),

  companyName: z
    .string()
    .trim()
    .min(1, "Company name is required")
    .max(50, "Company name must not exceed 50 characters")
    .regex(
      /^[A-Za-z\s]+$/,
      "Company name can only contain letters and spaces",
    ),
})
 .superRefine((data, ctx) => {
   if (data.contactNo.trim().length > 0 && !data.contactNoCountryCode.trim()) {
      ctx.addIssue({
        code: "custom",
        path: ["contactNoCountryCode"],
        message: "Please select a country code.",
      });
    }

    if (data.contactNoCountryCode === "+60") {
      const phone = data.contactNo; 

      // Malaysia mobile number must be exactly 9 or 10 digits
      if (phone.length !== 9 && phone.length !== 10) {
        ctx.addIssue({
          code: "custom",
          path: ["contactNo"],
          message: "Enter a valid Malaysian mobile number (e.g. 123456789)",
        });
      }

      // Cannot start with 0
      if (phone.startsWith("0")) {
        ctx.addIssue({
          code: "custom",
          path: ["contactNo"],
          message: "Enter a valid Malaysian mobile number (e.g. 123456789)",
        });
      }
    }
  });

export type UpdateProfileValues = z.infer<typeof ProfileSchema>;